import React from "react";
import styled, { css } from "styled-components";

import { IProductStatus } from "src/core/products/api/products.api";
import ProductStatusRow from "src/core/products/components/ProductStatuses/ProductStatusRow";
import { Text } from "src/library/components/Text";

interface CurrentProductStatusProps {
  currentStatus: IProductStatus;
}

/**
 * returns un-editable display of current product status: status, start date & end date
 */
const CurrentProductStatus: React.ReactFCWithChildren<CurrentProductStatusProps> = ({ currentStatus }) => {
  if (!currentStatus) {
    return null;
  }

  return (
    <ComponentWrapper>
      <Text
        as="h3"
        fontSize="h3"
      >
        Current Status
      </Text>

      <ProductStatusRow
        productStatus={currentStatus}
        productId={currentStatus.productId}
        disabled
      />
    </ComponentWrapper>
  );
};

const ComponentWrapper = styled.div`
  ${({ theme }) => css`
    padding: 0 0 ${theme.spacing.padding.lg} 0;
  `}
`;

export default CurrentProductStatus;
